import { render } from "./ThemeEditor.vue?vue&type=template&id=c0a91512"
import script from "./ThemeEditor.vue?vue&type=script&lang=js"
export * from "./ThemeEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__